<template>
  <div class="d-flex align-items-center flex-column" v-if="showMGMItem">
    <div
      class="position-relative d-inline-block w-100"
      style="cursor: pointer"
      @click="goInvite"
    >
      <svg class="w-100" viewBox="0 0 344 81">
        <use :xlink:href="'#' + mgmTemplateType" />
      </svg>
      <div
        class="position-absolute"
        style="top: 50%; z-index: 1"
        :style="mgmItemStyle"
      >
        <h5 class="m-0 text-truncate-1 mr-5">{{ mgmTemplateTitle }}</h5>
        <span class="font-size-md text-truncate-1 mr-5">{{ mgmTemplateDesc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['isMobile']),
    showMGMItem() {
      return ['MfcMgmBg01', 'MfcMgmBg02'].indexOf(this.mgmTemplateType) > -1;
    },
    mgmItemStyle() {
      switch (this.mgmTemplateType) {
        case 'MfcMgmBg01':
          return {
            left: '12.5%',
            'margin-top': '-12px',
          };

        case 'MfcMgmBg02':
          return {
            left: '4.5%',
            'margin-top': '-14px',
          };

        default:
          return {};
      }
    },
  },
  methods: {
    goInvite() {
      const routeData = {
        name: 'invite',
        query: {
          activityId: this.activityId,
          companyid: this.$store.state.companyId,
          membersourceid: this.$store.state.memberSourceId,
        },
      };

      if (!this.isMobile) {
        const routeResolveData = this.$router.resolve(routeData);
        window.open(routeResolveData.href, '_blank');
      } else {
        this.$router.push(routeData);
      }
    },
  },
  props: {
    activityId: String,
    mgmTemplateType: String,
    mgmTemplateTitle: String,
    mgmTemplateDesc: String,
  },
};
</script>

<style>
.svg-fill {
  fill: rgba(var(--theme-color)) !important;
}
</style>
